import React from "react";
import LandingLayout from "./LandingLayout";
import PlatformLayout from "./PlatformLayout";
import { LayoutWrapperProps } from "./Layout.props";

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
	children,
	layoutType = "landing",
}) => {
	const renderLayout = () => {
		switch (layoutType) {
			case "platform":
				return <PlatformLayout>{children}</PlatformLayout>;
			case "landing":
			default:
				return <LandingLayout>{children}</LandingLayout>;
		}
	};
	return renderLayout();
};

export default LayoutWrapper;
